<div class="userManagementTableFooter">
  <div class="userManagementTableFooter__textContainer">
    <div class="userManagementTableFooter__text">
      {{ 'account_settings_sites_footer' | ppTranslate: { count: ppNumberOfVisibleSites } }}
    </div>
  </div>
</div>
